import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const cursorUiEvents = eventGroup({
  source: 'Modeler Collab Cursor UI',
  events: {
    showCursors: type<void>(),
    hideCursors: type<void>(),
  },
});
